var _defs, _path, _path2, _path3, _path4, _path5, _path6, _g, _path7, _path8, _path9, _path0, _g2, _path1, _path10, _g3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVideoImage(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 270.24 216.14",
    width: "15em",
    height: "15em",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n        .cls-video-1, .cls-video-2 {\r\n            fill:#fff\r\n        }\r\n        \r\n        .cls-video-2, .cls-video-3 {\r\n            isolation:isolate\r\n        }\r\n        \r\n        .cls-video-3, .cls-video-4 {\r\n            opacity:.3\r\n        }\r\n        \r\n        .cls-video-5 {\r\n            fill:#286ac7\r\n        }\r\n        \r\n        .cls-video-2 {\r\n            opacity:.7\r\n        }\r\n      "))), /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-video-5",
    d: "M270.19 216.13.05 216.07.1 9.55C.11 4.28 4.38 0 9.65 0L260.7.06c5.27 0 9.55 4.28 9.54 9.55l-.05 206.52Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-video-2",
    d: "M.1 9.63.05 216.08l270.14.07.05-206.45c0-5.32-4.31-9.63-9.63-9.63L9.73 0C4.41 0 .1 4.31.1 9.63Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M160.46 102.12c0 13.46-10.92 24.37-24.38 24.37-13.46 0-24.37-10.92-24.37-24.38 0-13.46 10.92-24.37 24.38-24.37 13.46 0 24.37 10.92 24.37 24.38Z",
    style: {
      fill: "#0462c4"
    }
  }), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-video-1",
    d: "M125.8 112.42V91.81l25.77 10.31-25.77 10.29ZM0 196.62v19.49l270.11.01v-19.49L0 196.62Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-video-5",
    d: "M22.87 203.49v5.78l227.13.01v-5.78l-227.13-.01Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-video-2",
    d: "M22.87 203.49v5.78l227.13.01v-5.78l-227.13-.01ZM3.45 200.19v12.32h12.32v-12.32H3.45Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-video-5",
    d: "M7.54 210.33c-.64 0-1.17-.52-1.16-1.17v-5.6c0-.64.52-1.17 1.17-1.16.64 0 1.17.52 1.16 1.17v5.6c0 .64-.53 1.16-1.17 1.16ZM11.75 210.33c-.64 0-1.17-.52-1.16-1.17v-5.6c0-.64.52-1.17 1.17-1.16.64 0 1.17.52 1.16 1.17v5.6c0 .64-.53 1.16-1.17 1.16Z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-video-4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-video-3",
    d: "M7.54 210.33c-.64 0-1.17-.52-1.16-1.17v-5.6c0-.64.52-1.17 1.17-1.16.64 0 1.17.52 1.16 1.17v5.6c0 .64-.53 1.16-1.17 1.16ZM11.75 210.33c-.64 0-1.17-.52-1.16-1.17v-5.6c0-.64.52-1.17 1.17-1.16.64 0 1.17.52 1.16 1.17v5.6c0 .64-.53 1.16-1.17 1.16Z"
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-video-5",
    d: "M254.93 200.23v12.32h12.32v-12.32h-12.32Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-video-2",
    d: "M254.93 200.23v12.32h12.32v-12.32h-12.32Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-video-5",
    d: "M256.78 204.9v2.99h2.41v-2.99h-2.41Z"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    className: "cls-video-5",
    d: "m261.94 209.8-3.64-1.93v-2.98l3.65-1.92v6.83Z"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "cls-video-4"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-video-4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-video-3",
    d: "M256.78 204.9v2.99h2.41v-2.99h-2.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-video-3",
    d: "m261.94 209.8-3.64-1.93v-2.98l3.65-1.92v6.83Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-video-4"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-video-4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-video-3",
    d: "M263.74 204.11c.18-.19.37-.37.55-.56.62.63 1.02 1.38 1.13 2.26.18 1.32-.23 2.44-1.13 3.4l-.56-.56c.61-.63.94-1.39.94-2.27 0-.88-.34-1.64-.94-2.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-video-3",
    d: "M263.18 208.1c-.18-.18-.36-.37-.55-.55.31-.32.48-.71.48-1.17 0-.45-.17-.84-.49-1.16.18-.19.37-.37.55-.55.92.88 1 2.46 0 3.43Z"
  }))))), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    className: "cls-video-5",
    d: "M82.35 206.39c0 1.04.23 2.03.66 2.89H22.9v-5.81h60.13c-.42.88-.68 1.89-.68 2.92Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-video-5",
    d: "M95.55 206.39c0 1.04-.23 2.02-.66 2.89a6.627 6.627 0 0 1-5.95 3.7c-2.61 0-4.86-1.5-5.93-3.7-.43-.86-.66-1.85-.66-2.89s.25-2.05.68-2.91a6.53 6.53 0 0 1 5.9-3.7c2.61 0 4.84 1.5 5.93 3.7.43.86.68 1.87.68 2.91Z"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    className: "cls-video-4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-video-3",
    d: "M82.35 206.39c0 1.04.23 2.03.66 2.89H22.9v-5.81h60.13c-.42.88-.68 1.89-.68 2.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-video-3",
    d: "M95.55 206.39c0 1.04-.23 2.02-.66 2.89a6.627 6.627 0 0 1-5.95 3.7c-2.61 0-4.86-1.5-5.93-3.7-.43-.86-.66-1.85-.66-2.89s.25-2.05.68-2.91a6.53 6.53 0 0 1 5.9-3.7c2.61 0 4.84 1.5 5.93 3.7.43.86.68 1.87.68 2.91Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideoImage);
export default __webpack_public_path__ + "static/media/videoImage.ec5a5a7fc9f6f4caa7f4daca0cf759a8.svg";
export { ForwardRef as ReactComponent };